import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import {
  PRODUCT_CATEGORIES_PROFILE_FIELD,
  toProductCodes,
} from '../../constants/product.constants';
import type { ProductCode } from '../../models/product.model';
import { UserService } from '../user.service';
import type { ProductSource } from './product-source';

/** Reads the user's products from `Auth/me` (`insuranceProducts`). Provided in `app.config.ts`. */
@Injectable()
export class ApiProductSource implements ProductSource {
  private readonly userService = inject(UserService);

  async getAssignedProductCodes(): Promise<ProductCode[]> {
    // Always ask the server: the cached profile lives in browser storage and can be edited.
    const response = await firstValueFrom(this.userService.fetchUserProfile(true));
    const payload = response?.body as Record<string, unknown> | null;
    const profile = (payload?.['body'] as Record<string, unknown> | undefined) ?? payload;

    return toProductCodes(profile?.[PRODUCT_CATEGORIES_PROFILE_FIELD]);
  }
}
